module.exports = "query ReturnMotivesQuery{productReturnTypes(orderBy:\"-title\"){edges{node{id rowId title}}}}"